module.exports = __webpack_public_path__ + "img/wheelpointer.8f29d375.png";